<div #containerDivRef id="slick-popover_{{uuid}}" class="slick-popover slick-popover_{{position}}" [style.top.px]="top" [style.left.px]="left">
	<div #popoverContentRef class="popover fade bs-popover-{{position}} show">
		<div *ngIf="showArrow === true" class="arrow"></div>
		<div class="popover-body"><ng-content></ng-content></div>
	</div>
</div>
